module.exports = __webpack_public_path__ + "static/img/floor1-txt.0ba3b01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dh-map/floor1-txt.png
// module id = HeLH
// module chunks = 1